import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  cardButton,
} from 'shared/styles/commonStyles';



export const SwitchButtonWrapper = styled.button`
  width: ${(p) => p.$w || '100%'};
  height: ${(p) => p.$h || '40px'};
  ${cardButton}
  border-radius: 9999px;
  ${flexBoxCenter}
  color: var(--text-button, #cad5e2);
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

export const SwitchButtonHole = styled.div`
  ${flexBoxCenter}
  width: 100%;
  height: 100%;
`;

export const SwitchButtonTop = styled.div`
  ${flexBoxCenter}
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: var(--text-button, #cad5e2);

  ${(p) =>
    p.disabled &&
    css`
      color: #808080;
    `}
`;

export const MessageBoxWrapper = styled.div`
  width: auto;
  height: auto;

  ${flexBoxCenter}

  position: absolute;
  top: ${(p) => p.$top || '50px'};
  left: ${(p) => p.$left || '30px'};

  z-index: 100;
`;
